import { useState } from 'react';
import DSContractModal from '../design-system/DSContractModal';
import ContractAgreementForm from './ContractAgreementForm';

const ContractAgreementModal = () => {
  const [open, setOpen] = useState(true);

  return (
    <DSContractModal open={open}>
      <ContractAgreementForm onAccepted={() => setOpen(false)} />
    </DSContractModal>
  );
};

export default ContractAgreementModal;
